
export class ValidationRule {
  startsWith: string | null;
  minLength: number | null;
  maxLength: number | null;
  exactLength: number | null;
  isAlfaNumeric: boolean | null = null;
  propertyType: number | null = null;
  numberofLetters:number | null;
  regExp: string | null;
}

